import { ReactNode } from "react";
import { AnimationAttributes } from "./index";

interface BlockAnimationWrapperProps {
  attributes: AnimationAttributes;
  children: ReactNode;
}

export function BlockAnimationWrapper({
  attributes,
  children,
}: BlockAnimationWrapperProps) {
  return (
    <div
      className="af-anim-host"
      style={{ display: "contents" }}
      {...attributes}
    >
      {children}
    </div>
  );
}
